import React from "react";
import { Button } from "antd";
import "./style.less";
import Carous from "../../components/carsouel/index.js";
import Map from './componnets/map.js'
//import Carous from "../../components/carsouel/index.js"
import hcLogin from "../../assets/img/hc-login.jpg"
//import img2 from "../../assets/img/img_shouye_chanpin_02.png"
//import img3 from "../../assets/img/img_shouye_chanpin_03.png"
//import gongan from '../../assets/img/img_shouye_gonganbu.png'
//import yunnan from '../../assets/img/img_shouye_yunnan.png'
//import dezhou from '../../assets/img/img_shouye_dezhou.png'
//import tezhou from '../../assets/img/img_shouye_tengzhou.png'
//import houma from '../../assets/img/img_shouye_houma.png'
//import coreTechnique from "../coreTechnique";
import SimpleLunbo from "../../components/simpleLunbo/index.js";
import Foot from "../../components/footer/index.js"
export default class home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
      scrollHeight:0,
      board:[],
      flag:false,
    };
    //  this.handleClick = this.handleClick.bind(this)
  }
  //  handleClick(url) {
  //    this.props.history.push(url)
//   //  }
//   componentDidMount() {
//     window.addEventListener('scroll',this.handleScroll)
//   }
//   componentWillUnmount() {
//    //阻止请求
//    window.removeEventListener('scroll',this.handleScroll)
//  }
//  handleScroll = (e) => {
//   let {flag} = this.state
//   console.log(window.pageYOffset)
//   if(window.pageYOffset > 500&& !flag) {
//     this.setState({board:boardStyle,flag:true})
//   }

//  }
  render() {
    const { current,scrollHeight,board} = this.state;
    return (
      <div style={styles.home}>
        <div style={{ width: "100%" }}>
          <Carous />
        </div>

        <div className="bigTtile" style={{ marginTop: "40px" }}>
          <span>精选产品</span>
        </div>
        <div className="hc_con"
       >
          <div className="hc_part"  onClick={() => {
                    this.props.history.push("/product/3");
                  }}>
            <div className="hc_img">
              <img src={hcLogin}   className="boardImg" />
            </div >
              <div className="hc_con_content">
                <div className="hc_con_tip">
                  <span>农村交通安全风险智能研判系统</span>
                </div>

                <div className="hc_con_sub_content"><span>共享雪亮，创新建设模式、AI识别，量化安全风险、源头治理，消除安全隐患</span></div>
                <div><Button style={styles.button}>查看详情</Button></div>
              </div>
          </div>
        </div>
        <div
          style={{
            marginTop: 40,
            display: "flex",
            justifyContent: "center",
          }}

        >
          {boardStyle.map((item, index) => {
              return (
                <div
                  style={styles.boardCard}
                  key={index}
                  // className="InUP"
                  onClick={() => {
                    this.props.history.push(item.detail);
                  }}
                  className={this.state.flag?"bar-div":null}
                >
                  <div
                    style={{
                      border: "1px dashed #fff",
                      width: 392,
                      height: 272,
                      overflow: "hidden",
                    }}
                  >
                    <img src={item.img} className="boardImg" />
                  </div>
                  <div style={styles.Maintext}>
                    <span>{item.text1}</span>
                  </div>
                  <div style={styles.ViceText}>
                    <span>{item.text2}</span>
                  </div>
                  <div>
                    <Button style={styles.button}>查看详情</Button>
                  </div>
                </div>
              );
          })}
        </div>
        <div style={styles.coreTechnique}>
          <div className="bigTtile" style={{ marginBottom: "34px" }}>
            <span>核心技术</span>
          </div>
          <SimpleLunbo />
        </div>
        <div style={{ paddingBottom: "116px" }}>
          <div className="bigTtile" style={{ marginTop: 80 }}>
            <span>合作案例</span>
          </div>
          <div style={styles.case}>
            <ul className="list">
              {classicalCase.map((item, index) => {
                return (
                  <li
                    key={index}
                    className="subList"
                    onClick={() => this.setState({ current: index })}
                    style={current == index ? styles.sub : null}
                  >
                    {item.title}
                  </li>
                );
              })}
            </ul>
            <div className="home_content">
              <div className="card_content">
                <div style={styles.subTitle}>
                  <span>{classicalCase[current].content1}</span>
                </div>
                <div style={{ textAlign: "left", color: "#000", opacity: 0.6 }}>
                  <span>{classicalCase[current].content2}</span>
                </div>
              </div>
              <div style={{width:490,height:'100%',position:'relative'}}>
              <span style={styles.subTitleMap}>
              <span>{"合作单位"}</span>
              </span>
                <Map  />
              </div>
            </div>
          </div>
        </div>
        <Foot/>
      </div>
    );
  }
}
const classicalCase = [
  {
    title: "公安部某某局",
    content1: "大数据研判平台",
    content2:
      "我公司为公安部某某局“大数据研判平台”及配套APP项目的设计研发提供技术支持。",
    img: require("../../assets/img/img_shouye_gonganbu.png").default,
  },
  {
    title: "云南省厅",
    content1: "大数据平台",
    content2:
      "公司深入参与云南省厅公安大数据领域建设，依托我司大数据治理能力、AI机器学习算法等领域积累的丰富经验，参与了多项实战化产品和项目的落地。",
    img: require("../../assets/img/img_shouye_yunnan.png").default,
  },
  {
    title: "德州公安",
    content1: "德州公安一体化实战平台",
    content2:
      "德州公安立体侦查打击主题应用系统，是在德州现有刑侦信息专业应用系统、多元数据实战应用中心等项目与公安各业务信息系统的基础上，通过对数据和业务模块进行梳理、整合、优化、扩展，实现业务流和信息流的高度融合，打通信息壁垒，建设成先进的专业化、一体化、智能化侦查研判工作平台，通过对案发现场的数据进行立体式全采集，依托模型算法筛查犯罪嫌疑人线索、智能化关联、碰撞比对，实现由案到人、由案到案、由人到案的侦查工作模式，达到公安警务信息的高度关联共享与应用，极大提升刑侦工作效能。",
    img: require("../../assets/img/img_shouye_dezhou.png").default,
  },
  {
    title: "晋城公安",
    content1: "关注目标工作系统",
    content2:
      "系统部署于业务内网，对接各类大数据资源，建设强大的可配置模型比对引擎与预警方案，实时比对，推送工作线索。",
    img: require("../../assets/img/img_shouye_tengzhou.png").default,
  },
  {
    title: "侯马公安",
    content1: "新橙追影-特征目标识别追踪系统（平台）",
    content2:
      "侯马公安视频追踪系统，是我司新橙新橙追影特征目标识别追踪系统（平台）产品的落地项目，是针对公安刑事案件侦查、目标管控等工作中各类视频实战高频应用场景，以海量视频监控信息（天网/雪亮）为数据源，以目标行人体态特征为条件，采用“以人搜视频”的新橙AI算法，实现高效率搜索与高精度识别，刻画目标行人的视频活动轨迹，彻底扭转了现有视频应用中需要大量人力查看视频的局面，极大的提升了视频侦查效率。",
    img: require("../../assets/img/img_shouye_houma.png").default,
  },
  {
    title: "沁水公安",
    content1: "新橙慧安-合成研判平台",
    content2:
    "沁水公安多维管控研判系统，是新橙慧安-合成研判平台产品的落地项目。平台对接视频、人脸、车辆卡口、热点、GIS地图等系统，应用AI、大数据、可视化技术，基于GIS地图关联融合数据资源，打通应用体系，通过系统合成作战，提升案件侦查、目标管控等综合研判能力，提升基层警方的整体作战能力。",
    img: require("../../assets/img/img_shouye_dezhou.png").default,
  },
  {
    title: "深圳刑侦",
    content1: "新橙追影-特征目标识别追踪系统（单兵）",
    content2:
      "针对“人眼查看视频”耗时耗力、易漏目标等痛点问题，北京新橙智慧科技发展有限公司采用新一代AI智能化技术，研发出新橙追影-特征目标识别追踪系统（单兵）。该系统操作简便，算法强大，功能实用，可以跨境追踪目标，刻画活动轨迹，生成研判报告，助力快速侦破案件，是目前视频侦查领域最佳解决方案，具有高效率、高可靠性、高性价比等特点。",
    img: require("../../assets/img/img_shouye_tengzhou.png").default,
  },
  {
    title: "北京海淀",
    content1: "新橙追影-特征目标识别追踪系统（单兵）",
    content2:"针对“人眼查看视频”耗时耗力、易漏目标等痛点问题，北京新橙智慧科技发展有限公司采用新一代AI智能化技术，研发出新橙追影-特征目标识别追踪系统（单兵）。该系统操作简便，算法强大，功能实用，可以跨境追踪目标，刻画活动轨迹，生成研判报告，助力快速侦破案件，是目前视频侦查领域最佳解决方案，具有高效率、高可靠性、高性价比等特点。",
    img: require("../../assets/img/img_shouye_houma.png").default,
  },
  {
    title: "尉犁公安",
    content1: "新橙追影-特征目标识别追踪系统（单兵）",
    content2:
    "针对“人眼查看视频”耗时耗力、易漏目标等痛点问题，北京新橙智慧科技发展有限公司采用新一代AI智能化技术，研发出新橙追影-特征目标识别追踪系统（单兵）。该系统操作简便，算法强大，功能实用，可以跨境追踪目标，刻画活动轨迹，生成研判报告，助力快速侦破案件，是目前视频侦查领域最佳解决方案，具有高效率、高可靠性、高性价比等特点。",
    img: require("../../assets/img/img_shouye_houma.png").default,
  },
  {
    title: "贺兰公安",
    content1: "新橙追影-特征目标识别追踪系统（单兵）",
    content2:
    "针对“人眼查看视频”耗时耗力、易漏目标等痛点问题，北京新橙智慧科技发展有限公司采用新一代AI智能化技术，研发出新橙追影-特征目标识别追踪系统（单兵）。该系统操作简便，算法强大，功能实用，可以跨境追踪目标，刻画活动轨迹，生成研判报告，助力快速侦破案件，是目前视频侦查领域最佳解决方案，具有高效率、高可靠性、高性价比等特点。",
    img: require("../../assets/img/img_shouye_houma.png").default,
  },
];

const boardStyle = [
  {
    img: require("../../assets/img/chanpintu_1.png").default,
    text1: "新橙慧安合成研判平台",
    text2: "数据融合/多维算法/合成作战/精准研判",
    detail: "/product/0",
  },
  {
    img: require("../../assets/img/img_shouye_chanpin_02.jpg").default,
    text1: "新橙追影-视频研判系统【集群】",
    text2: "利旧立现/精准算法/跨镜追踪/在线地图",
    detail: "/product/1",
  },
  {
    img: require("../../assets/img/img_shouye_chanpin_03.jpg").default,
    text1: "新橙追影-视频研判系统【单兵】",
    // text2: "离线使用/AI算法/强悍硬件/便利工具",
    text2: "操作简便/算法强大/功能实用/性价比高",
    detail: "/product/2",
  },
];

const styles = {
  home: {
    width: "100%",
    textAlign: "center",
    background: "#F5F6F7",
    height:560
  },
  boardCard: {
    width:'400',
     height: "462",
    background: "#FFFFFF",
    boxShadow: "4px 4px 10px 0px rgba(0, 0, 0, 0.12)",
    textAlign: "center",
    margin: "0px 22.5px",
    padding: 4,
    cursor: "pointer",
  },
  img: {
    width: 392,
    height: 272,
  },
  Maintext: {
    fontSize: "20px",
    fontFamily: "PingFangSC-Medium, PingFang SC",
    fontWeight: "500",
    color: "#222222",
    lineHeight: "20px",
    marginTop: "30px",
  },
  ViceText: {
    fontSize: "14px",
    fontFamily: "PingFangSC-Medium, PingFang SC",
    fontWeight: "400",
    color: "#999",
    lineHeight: "14px",
    marginTop: "18px",
  },
  button: {
    height: "36",
    borderRadius: "20",
    border: "2px solid #F4AA14",
    padding: "0 24px",
    color: "#F4AA14",
    fontSize: 14,
    fontFamily: "PingFangSC-Regular, PingFang SC",
    margin: "34px 0",
  },
  coreTechnique: {
    width: "100%",
    backgroundImage:'url(' + require('../../assets/img/img_shouye_hexinjishu.jpg').default + ')',
    backgroundSize:'100% 100%',
    marginTop: 128,
    padding: "80px 0",
  },
  case: {
    width: 1280,
    height: 512,
    background: "#FFFFFF",
    boxShadow: "8px 8px 12px 0px rgba(0, 0, 0, 0.12)",
    margin: "0 auto",
    marginTop: 60,
    display: "flex",
  },
  sub: {
    borderLeft: "3px solid #F4AA14",
    background: "#fff",
    color: "#F4AA14",
    fontWeight: 600,
  },
  subTitle: {
    lineHeight: "20px",
    fontSize: "20px",
    marginBottom: "35px",
    fontWeight: 600,
    background:
      "linear-gradient(180deg, rgba(213, 157, 34, 0) 0%, rgba(243, 175, 30, 0.2) 100%)",
  },
  subTitleMap:{
    lineHeight: "20px",
    fontSize: "20px",
     position:'absolute',
     top:'20px',
     left:'30px',
    fontWeight: 600,
    background:
      "linear-gradient(180deg, rgba(213, 157, 34, 0) 0%, rgba(243, 175, 30, 0.2) 100%)",
  }
};
